import { render, staticRenderFns } from "./AppDetail.vue?vue&type=template&id=177ac988&scoped=true"
import script from "./AppDetail.vue?vue&type=script&lang=ts"
export * from "./AppDetail.vue?vue&type=script&lang=ts"
import style0 from "./AppDetail.vue?vue&type=style&index=0&id=177ac988&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177ac988",
  null
  
)

export default component.exports